import { render, staticRenderFns } from "./CfgInstanciaParceira.vue?vue&type=template&id=4de311af&scoped=true&"
import script from "./CfgInstanciaParceira.vue?vue&type=script&lang=js&"
export * from "./CfgInstanciaParceira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de311af",
  null
  
)

export default component.exports